/**
 *  nsExpiredMonth will throw a nsExpiredMonth validation error for the field
 *
 *  Usage: ns-expired-month="name of expiration year property"
 *     ex: ns-expired-month="expYear"
 */
import {utilModule} from '../module.js';

utilModule.directive('nsExpiredMonth', function() {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {
            let today       = new Date();
            let year        = today.getFullYear() - 2000;
            let month       = today.getMonth() + 1;
            let modelPath   = attr.ngModel.substr(0,attr.ngModel.lastIndexOf("."));

            // Read the name of the expYear model property
            let expYearString = modelPath + "." + attr.nsExpiredMonth;
            let expMonthString = attr.ngModel;

            scope.$watch(expYearString, function() {
                checkDate();
            });

            scope.$watch(expMonthString, function() {
                checkDate();
            });

            function checkDate() {
                if (scope.$eval(expYearString) == (year) && Number(scope.$eval(expMonthString) < month)) {
                    ctrl.$setValidity('nsExpiredMonth', false);
                } else {
                    ctrl.$setValidity('nsExpiredMonth', true);
                }
            }
        }
    };
});
